import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el Mega Pack después de comprar?',
  a: 'Recibirás el acceso al material de forma inmediata para que puedas empezar a usarlo cuanto antes, sin esperas ni trámites.'
}, {
  q: '¿Para qué nivel educativo está pensado?',
  a: 'El material está diseñado para docentes de educación media técnica, bachillerato técnico, escuelas agropecuarias, institutos de formación profesional y nivel superior técnico de toda América Latina.'
}, {
  q: '¿Sirve para cualquier país de América Latina?',
  a: 'Sí. El material está escrito en español neutro latinoamericano y cada receta, formulación y ejemplo incluye datos específicos por país: precios de mercado, zonas productoras, normativas sanitarias y variantes regionales de Argentina, Colombia, México, Chile, Brasil, Perú, Uruguay, Ecuador, Bolivia, Venezuela, Paraguay y Centroamérica.'
}, {
  q: '¿El material es editable?',
  a: 'El material se entrega en formato PDF listo para usar. Podés imprimirlo, proyectarlo en el taller o entregarlo digitalmente a tus alumnos sin necesidad de ningún programa especial.'
}, {
  q: '¿En qué moneda voy a pagar?',
  a: 'Pagás en tu moneda local. El sistema convierte el precio automáticamente según el país desde donde comprás.'
}, {
  q: '¿Qué incluye la oferta especial de 27,90?',
  a: 'Incluye los 5 tomos del Mega Pack principal más los 3 tomos del Pack Maestro Avanzado: conservas y fermentados avanzados, embutidos artesanales avanzados y fermentados cárnicos, y lácteos premium. Son 8 tomos en total con más de 480 páginas de contenido técnico, recetas con formulaciones exactas, evaluaciones, proyectos productivos y análisis económico por país.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tenés 7 días de garantía total. Si no estás satisfecho por cualquier motivo, te devolvemos el 100% de tu dinero sin preguntas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-dark-card" data-id="element-79">
      <div className="max-w-3xl mx-auto" data-id="element-80">
        <div className="text-center mb-16" data-id="element-81">
          <h2 className="text-3xl md:text-5xl font-serif font-bold" data-id="element-82">
            ❓ Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-83">
          {faqs.map((faq, index) => <div key={index} className="bg-black border border-dark-border rounded-xl overflow-hidden" data-id="element-84">
              <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-85">
                <span className="font-bold text-lg text-white pr-8" data-id="element-86">
                  {faq.q}
                </span>
                <ChevronDown className={`text-gold transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-87" />
              </button>

              <AnimatePresence data-id="element-88">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-89">
                    <div className="px-6 pb-5 text-gray-300 border-t border-dark-border/50 pt-4" data-id="element-90">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}